export const SOFTWARE_VERSION = Object.freeze({
  softwareVersion: "1.1.163",
  softwareDate: "2025-03-20T01:18Z",
})
